import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import { keysToCamel } from '@shared/helpers/snakeToCamel';
import {
    createBudgetItemFunc,
    createExcessFunc,
    ordersRecognitionDeleteFunc,
    ordersRecognitionListFunc,
    ordersRecognitionSearchFunc,
    ordersRecognitionUploadFunc,
    saveExcessItemCommentFunc,
    saveOrderCommentFunc,
    setItemProceedFunc,
    updateBudgetItemFunc,
    updateCheckStatusDateFunc,
    updateItemSupplierFunc,
    updateExcessCheckStatusDateFunc,
} from '@widgets/OrdersRecognition/api/api-funcs';
import {
    ORDERS_RECOGNITION_LIST,
    ORDERS_RECOGNITION_SEARCH,
} from '@widgets/OrdersRecognition/model/queryKeys';
import {
    ActiveDrag,
    IRequestedDataToMove,
    TOrderItem,
    TOrdersRecognitionListResponse,
} from '@widgets/OrdersRecognition/model/types';

export const ordersRecognitionApi = {
    getOrdersRecognitionListQueryOptions: () =>
        queryOptions({
            queryKey: ORDERS_RECOGNITION_LIST,
            queryFn: (meta) => ordersRecognitionListFunc({ signal: meta.signal }),
            select: (data) => keysToCamel<TOrdersRecognitionListResponse>(data?.data?.data),
            refetchOnMount: false,
            placeholderData: keepPreviousData,
        }),
    // getOrdersRecognitionSearchQueryOptions: ({ queryState }: { queryState: string }) => {
    //     const queryString = (queryState ?? '').trim();
    //     const enabled = queryString.length > 0;
    //     return queryOptions({
    //         queryKey: ['ordersRecognition', 'search', queryString],
    //         queryFn: (meta) => ordersRecognitionSearchFunc({ signal: meta.signal }, queryString),
    //         select: (data) => keysToCamel<TOrderItem[]>(data?.data?.data),
    //         refetchOnMount: false,
    //         placeholderData: keepPreviousData,
    //         enabled,
    //     });
    // },
    getOrdersRecognitionSearchQueryOptions: ({ queryString }: { queryString: string }) =>
        queryOptions({
            queryKey: [...ORDERS_RECOGNITION_SEARCH, queryString],
            queryFn: (meta) => ordersRecognitionSearchFunc({ signal: meta.signal }, queryString),
            select: (data) => keysToCamel<TOrdersRecognitionListResponse>(data?.data?.data),
            refetchOnMount: false,
            // placeholderData: keepPreviousData,
        }),
    uploadOrder: (data: FormData) => ordersRecognitionUploadFunc(data),
    deleteOrder: (orderId: TOrderItem['id']) => ordersRecognitionDeleteFunc(orderId),
    createExcessItem: ({ estimateId, data }: { estimateId: string; data: IRequestedDataToMove }) =>
        createExcessFunc({ estimateId, data }),
    createBudgetItem: ({
        positionCheckGuid,
        positionGuid,
        data,
    }: {
        positionCheckGuid: string;
        positionGuid: string;
        data: IRequestedDataToMove;
    }) => createBudgetItemFunc({ positionCheckGuid, positionGuid, data }),
    updateBudgetItem: ({
        positionCheckGuid,
        positionGuid,
        data,
    }: {
        positionCheckGuid: string;
        positionGuid: string;
        data: IRequestedDataToMove;
    }) => updateBudgetItemFunc({ positionCheckGuid: positionCheckGuid || positionGuid, data }),
    updateItemSupplier: ({
        itemGuid,
        supplier,
    }: {
        itemGuid: string;
        supplier: IRequestedDataToMove['supplier'];
    }) => updateItemSupplierFunc(itemGuid, supplier),
    saveOrderComment: ({ itemGuid, displayString }: { itemGuid: string; displayString: string }) =>
        saveOrderCommentFunc(itemGuid, displayString),
    saveExcessComment: ({ itemGuid, displayString }: { itemGuid: string; displayString: string }) =>
        saveExcessItemCommentFunc(itemGuid, displayString),
    // moveBudgetItem: (itemGuid: string) => console.log('move item'),
    setItemProceed: ({ itemType, itemId }: { itemType: ActiveDrag['type']; itemId: string }) =>
        setItemProceedFunc(itemType, itemId),
    updateItemDate: ({ documentDate, itemGuid }: { documentDate: string; itemGuid: string }) =>
        updateCheckStatusDateFunc(documentDate, itemGuid),
    updateExcessItemDate: ({
        documentDate,
        itemGuid,
    }: {
        documentDate: string;
        itemGuid: string;
    }) => updateExcessCheckStatusDateFunc(documentDate, itemGuid),
};
